import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { connect } from 'react-redux';

import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';

import { scale, isAdmin } from '@components/frame';

import TouchableElement from '@components/common/touchableElement';
import UserImage from '@components/common/UserImage';
import Line from '@components/common/line';

import { updateUserInfo, updateCompanyProfile } from '@reducers/user';
import { updateUserProfile } from '@reducers/membership';
import { modalFieldBg, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const EditAccount = ({
  hide,
  C,
  updateUserInfo,
  setEditFieldConfig,
  toggleEditField,
  updateCompanyProfile,
  updateUserProfile,
  user: { userInfo = {} },
}) => {
  const { userProfile = {}, companyProfile = {}, emailAddress = ' ' } = userInfo;
  const { firstName = ' ', lastName = ' ' } = userProfile;

  const profile = [
    {
      name: i18n.t('Name'),
      value: `${firstName} ${lastName}`,
      noArrow: false,
      onClick: () => {
        setEditFieldConfig({
          header: 'Your Name',
          subHeader: `${i18n.t('Edit your name')}`,
          initData: {
            firstName: firstName,
            lastName: lastName,
          },
          onSubmit: async (data, onClose) => {
            await updateUserProfile({
              emailAddress: emailAddress,
              userProfile: data,
            });
            await updateUserInfo(data);
            onClose();
          },
          inputs: [
            {
              key: 'firstName',
              name: 'First name',
              noArrow: true,
              lableWidth: scale(110),
            },
            {
              key: 'lastName',
              name: 'Last name',
              noArrow: true,
              lableWidth: scale(110),
            },
          ],
        });
        toggleEditField();
      },
    },
    { name: i18n.t('Email'), value: emailAddress, noArrow: true },
    {
      name: i18n.t('Company'),
      value: companyProfile.companyName,
      noArrow: !isAdmin,
      onClick: () => {
        if (!isAdmin) {
          return;
        }
        setEditFieldConfig({
          header: 'Your Company',
          subHeader: `${i18n.t('Edit your company')}`,
          initData: {
            companyName: companyProfile.companyName,
          },
          onSubmit: async (data, onClose) => {
            await updateUserProfile({
              emailAddress: emailAddress,
              companyProfile: data,
              userProfile: {
                firstName: firstName,
                lastName: lastName,
              },
            });
            await updateCompanyProfile(data);
            onClose();
          },
          inputs: [
            {
              key: 'companyName',
              name: 'Company',
              noArrow: true,
              lableWidth: scale(110),
            },
          ],
        });
        toggleEditField();
      },
    },
  ];

  return (
    <View style={{ marginBottom: scale(15) }}>
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          zIndex: 1000,
          height: scale(54),
        }}
      >
        <View>
          <TouchableElement onPress={hide}>
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle, { padding: scale(15) }]}>
                <Text style={[{ color: C(pressHoverColor('System/Light/Blue')) }, font.Body]}>{i18n.t('Close')}</Text>
              </View>
            )}
          </TouchableElement>
        </View>
      </View>
      <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
        <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Edit Account')}</Text>
      </View>
      <View style={{ width: '100%', alignItems: 'center', marginTop: scale(18) }}>
        <UserImage {...{ showEdit: true, showAdd: true }} />
      </View>
      <View style={{ marginTop: scale(24), paddingHorizontal: scale(15) }}>
        <View
          style={[
            getBoxShadowStyle({ type: 'Field', C }),
            {
              width: '100%',
              borderRadius: scale(SCREEN_BORDER_RADIUS),
            },
          ]}
        >
          {profile.map((item, index) => (
            <Line
              {...{
                item,
                index,
                array: profile,
                C,
                roundTop: index === 0,
                roundBottom: index === profile.length - 1,
                noArrow: item.noArrow,
                bg: modalFieldBg,
              }}
              key={item.name}
            />
          ))}
        </View>
      </View>
    </View>
  );
};
export default connect(({ user }) => ({ user }), { updateUserInfo, updateCompanyProfile, updateUserProfile })(ColorWrapper(EditAccount));
